type CategoryTagProps = {
	value: {
		name: string;
		color: string;
	};
};
export const CategoryTag = ({
	value,
}: {
	value: CategoryTagProps["value"];
}) => {
	if (!value || !value.name || !value.color) {
		return null;
	}
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				gap: "8px",
			}}
		>
			<div
				style={{
					backgroundColor: value.color,
					width: "26px",
					height: "26px",
					borderRadius: 4,
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					color: "#fff",
					fontWeight: "bold",
					flexShrink: 0,
				}}
			>
				{value.name.charAt(0).toUpperCase()}
			</div>
			<span style={{ whiteSpace: "nowrap" }}>{value.name}</span>
		</div>
	);
};
